import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizInstructionsEdit;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import CustomPropTypes from '../../../../../../common/util/CustomPropTypes';
import { checkClickedNode } from '../../../../../../common/util/clickHandlers';
import { INSTRUCTIONS_EDIT_ID, withStyleOverrides } from '@instructure/quiz-common';
import { RichContentInput } from '@instructure/quiz-rce';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import wrapWithOutsideClickEmotion from '../../../../../../common/components/shared/functionality/componentWithOutsideClickEmotion';

// ===================================

// once editing is toggled this div
// is rendered & has actions that
// allow for canceling

// ===================================
var QuizInstructionsEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizInstructionsEdit = /*#__PURE__*/function (_Component) {
  function QuizInstructionsEdit() {
    _classCallCheck(this, QuizInstructionsEdit);
    return _callSuper(this, QuizInstructionsEdit, arguments);
  }
  _inherits(QuizInstructionsEdit, _Component);
  return _createClass(QuizInstructionsEdit, [{
    key: "clickedOutside",
    value:
    // enabled by wrapWithOutsideClick
    function clickedOutside() {
      this.props.saveAndPreview();
    }

    // enabled by wrapWithOutsideClick
  }, {
    key: "ignoreClickOutsideIf",
    value: function ignoreClickOutsideIf(e) {
      var _checkClickedNode = checkClickedNode(e, this.props.appContainer),
        isEndEditingTrigger = _checkClickedNode.isEndEditingTrigger,
        outsideApp = _checkClickedNode.outsideApp;
      return outsideApp || !isEndEditingTrigger;
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.instructionsEditWrapper
      }, jsx(RichContentInput, {
        autoFocus: true,
        label: "",
        textareaId: INSTRUCTIONS_EDIT_ID,
        defaultContent: this.props.inputValue,
        onKeyUp: this.props.onInputChange,
        onChange: this.props.onInputChange
      }), jsx("div", {
        css: this.props.styles.footer
      }, jsx(Button, {
        margin: "0 x-small",
        onClick: this.props.endEditing
      }, t('Cancel')), jsx(Button, {
        color: "primary",
        onClick: this.props.saveAndPreview,
        "data-automation": "instructions-done"
      }, t('Done'))));
    }
  }]);
}(Component), _defineProperty(_QuizInstructionsEdit, "displayName", 'QuizInstructionsEdit'), _defineProperty(_QuizInstructionsEdit, "componentId", "Quizzes".concat(_QuizInstructionsEdit.displayName)), _defineProperty(_QuizInstructionsEdit, "propTypes", {
  endEditing: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  saveAndPreview: PropTypes.func.isRequired,
  appContainer: CustomPropTypes.selectors.isRequired,
  styles: PropTypes.object
}), _QuizInstructionsEdit)) || _class);
export default wrapWithOutsideClickEmotion(QuizInstructionsEdit);